// Lucian UX/UI Prompt #047 · MIT License (c) 2026 Seokwoooo · https://lucianlabs.dev/uxui-prompt/#047
// 期間の切り替え。つまみは進む側の端が先に動き、後ろの端がばねで追いつく（伸びて滑る）。左右キーでも動かせる。
import React, { useLayoutEffect, useRef, useState } from 'react';
import './lucian.css';

export default function PeriodSegmented({ options, value, onChange, label = '期間' }) {
  const wrap = useRef(null);
  const btns = useRef({});
  const [knob, setKnob] = useState(null);
  const lastIndex = useRef(options.findIndex(o => o.value === value));

  useLayoutEffect(() => {
    const place = () => {
      const el = btns.current[value];
      const box = wrap.current;
      if (!el || !box) { setKnob(null); return; }
      const idx = options.findIndex(o => o.value === value);
      const dir = idx >= lastIndex.current ? 'is-right' : 'is-left';
      lastIndex.current = idx;
      setKnob({ left: el.offsetLeft, right: box.clientWidth - el.offsetLeft - el.offsetWidth, dir });
    };
    place();
    window.addEventListener('resize', place);
    return () => window.removeEventListener('resize', place);
  }, [value, options]);

  const onKey = (e) => {
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    e.preventDefault();
    const i = options.findIndex(o => o.value === value);
    const j = Math.max(0, Math.min(options.length - 1, i + (e.key === 'ArrowRight' ? 1 : -1)));
    if (j !== i) { onChange(options[j].value); btns.current[options[j].value]?.focus(); }
  };

  return (
    <div className="lx lx-seg" ref={wrap} role="radiogroup" aria-label={label} onKeyDown={onKey}>
      {knob && <span className={`lx-seg__knob ${knob.dir}`} style={{ left: knob.left, right: knob.right }} aria-hidden="true" />}
      {options.map(o => (
        <button
          key={o.value}
          ref={el => { btns.current[o.value] = el; }}
          type="button"
          role="radio"
          aria-checked={o.value === value}
          tabIndex={o.value === value ? 0 : -1}
          className="lx-seg__opt"
          onClick={() => onChange(o.value)}
        >{o.label}</button>
      ))}
    </div>
  );
}
